import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { auth } from './Sign/firebase';
import { TiMessageTyping } from "react-icons/ti";
import { FaHome } from 'react-icons/fa';
import { FaChalkboard, FaCode, FaMoon } from 'react-icons/fa6';
import { LiaBlogSolid, LiaToolsSolid } from "react-icons/lia";
import { CiLight } from "react-icons/ci";


const SubHeader = () => {
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    const [headerColor, setHeaderColor] = useState('default');
    const [theme, setTheme] = useState('light');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleToggle = () => {
        setIsNavbarOpen(!isNavbarOpen);
    };

    const toggleTheme = () => {
        setTheme(prev => prev === 'light' ? 'dark' : 'light');
        setHeaderColor('default');
    };

    const activateRedTheme = () => {
        setHeaderColor('red');
    };

    return (
        <>
            <nav className={`navbar navbar-expand-lg ${headerColor === 'red'
                    ? 'header-red'
                    : theme === 'light'
                        ? 'header-light'
                        : 'header-dark'
                }`}>

                <div
                    style={{ justifyContent: 'space-between' }}
                    className={`collapse navbar-collapse ${isNavbarOpen ? 'show' : ''}`}
                    id='navbarNav'
                >
                    <ul className='navbar-nav'>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/'}>
                                <FaHome /> Home
                            </NavLink>
                        </li>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/WhiteBoard'}>
                                <FaChalkboard /> WhiteBoard
                            </NavLink>
                        </li>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/TryEditor'}>
                                <FaCode /> Online Compilers
                            </NavLink>
                        </li>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/TypingMaster'}>
                                <TiMessageTyping /> Typing Master
                            </NavLink>
                        </li>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/blogs'}>
                                <LiaBlogSolid /> Blogs
                            </NavLink>
                        </li>
                        <li className='nav-item active'>
                            <NavLink className='nav-link' to={'/tools'}>
                                <LiaToolsSolid /> Tools
                            </NavLink>
                        </li>

                    </ul>
                    <div style={{ justifyContent: 'center', display: 'flex', gap: '10px', marginRight: '20px' }}>
                        <button onClick={toggleTheme} className="darkModeBtn">
                            {theme === 'light' ? (<CiLight />) : (<FaMoon />)}
                        </button>
                        <button onClick={activateRedTheme} className="greenRedBtn">
                            {theme === 'light' ? "" : ""}
                        </button>
                    </div>
                </div>
            </nav>
        </>
    );
};

export default SubHeader;
